import axios from 'axios';
import OrderItemsActions from './actions/orderitems';
import KeyGenActions from './actions/keygen';
import OrderMessagesActions from './actions/ordermessages';
import SingleConfigsActions from './actions/singleconfigs';

//If you add a custom repository in this array it will be dynamically added to the repository custom options when get: is called.
const actions = {
  orderitems: OrderItemsActions,
  ordermessages: OrderMessagesActions,
  keygen: KeyGenActions,
  singleconfigs: SingleConfigsActions,
};

class Repository {
  //Generate a repository for the resource (The /controller route with all the main and custom routes)
  constructor(resource, organisationCode) {
    this.publicUrl = process.env.VUE_APP_API_URL + 'public/';
    this.resource = resource;
    this.customConfig = {
      headers: {
        Organisationcode: organisationCode,
      },
    };

    let customActions = actions[resource];

    if (customActions != undefined) {
      this.actions = new customActions(
        this.resource,
        this.publicUrl,
        this.customConfig
      );
    }
  }

  getAll() {
    return axios.get(`${this.publicUrl}${this.resource}`, this.customConfig);
  }
  get(idPublic) {
    return axios.get(
      `${this.publicUrl}${this.resource}/${idPublic}`,
      this.customConfig
    );
  }
  create(payload) {
    return axios.post(
      `${this.publicUrl}${this.resource}`,
      payload,
      this.customConfig
    );
  }
  update(payload, idPublic) {
    return axios.put(
      `${this.publicUrl}${this.resource}/${idPublic}`,
      payload,
      this.customConfig
    );
  }
  delete(idPublic) {
    return axios.delete(
      `${this.publicUrl}${this.resource}/${idPublic}`,
      this.customConfig
    );
  }
}

//When you get any repository with his name in parameter it will generate a repository with all the default and custom routes.
export default {
  get: (name, organisationCode = 0) => {
    return new Repository(name, organisationCode);
  },
};
